module.exports = __webpack_public_path__ + "assets/img/logo.dedaae0e.png";